import type { FC } from 'react';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from '../../context/LocationContext';
import { createDigitalBillOverviewUrl } from '../../utils/linkBuilder';
import Spinner from '../../components/Spinner';

const SettledBillsPage = lazy(() => import('./settled/SettledBillsPage'));
const UnsettledBillsPage = lazy(() => import('./unsettled/UnsettledBillsPage'));

const DigitalBillSwitch: FC = () => {
  const { location } = useLocation();

  return (
    <main className="h-main grid tablet:grid-cols-12 auto-rows-min tablet:auto-rows-auto bg-grey-lightest">
      <Suspense fallback={<Spinner className="m-auto mt-6 w-8 h-8" />}>
        <Routes>
          <Route path="settled/*" element={<SettledBillsPage />} />
          <Route path="unsettled/*" element={<UnsettledBillsPage />} />
          <Route path="*" element={<Navigate to={createDigitalBillOverviewUrl(location.locationId)} replace />} />
        </Routes>
      </Suspense>
    </main>
  );
};

export default DigitalBillSwitch;
